import * as Yup from 'yup';
import { isRequiredFunc, isEmailFunc } from '../../Shared/Schema';

export const forgotSchema = Yup.object().shape({
  email: Yup.string()
    .required(isRequiredFunc('Email'))
    .email(isEmailFunc('Email')),
});
